export default __webpack_public_path__ + "static/sa-9083a46437d137de49e93ba6a18af78e.svg";